<template>
  <div class="main">
    <Header
      :show="true"
      title="编辑原料入库"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div class="content">
      <van-form
        ref="owdrForm"
        validate-first
        @submit="submit"
      >
        <van-field
          name="port"
          label="罐料口"
          placeholder="请选择罐料口"
          :value="selectPort"
          readonly
          clickable
          required
          :rules="[{ required: true, message: '请选择罐料口' }]"
          @click="showPortPicker = true"
        />
        <van-popup
          v-model="showPortPicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="pickerPortList"
            @confirm="handleConfirmPortPicker"
            @cancel="showPortPicker = false"
          />
        </van-popup>
        <van-field
          name="material"
          label="物料"
          placeholder="请选择物料"
          :value="form.data.material"
          readonly
          clickable
          required
          :rules="[{ required: true, message: '请选择物料' }]"
          @click="showMaterialPicker = true"
        />
        <van-popup
          v-model="showMaterialPicker"
          position="bottom"
        >
          <van-picker
            show-toolbar
            :columns="pickerMaterialList"
            @confirm="
              form.data.material = $event;
              showMaterialPicker = false;
            "
            @cancel="showMaterialPicker = false"
          />
        </van-popup>

        <van-field
          v-model="form.data.supplier"
          name="supplier"
          label="供应商"
          placeholder="请输入供应商"
          required
          :rules="[{ required: true, message: '供应商不能为空' }]"
        />
        <van-field
          v-model="form.data.plateNumber"
          name="plateNumber"
          label="车牌号"
          placeholder="请输入车牌号"
          required
          :rules="[{ required: true, message: '车牌号不能为空' }]"
        />
        <van-field
          v-model="form.data.driver"
          name="driver"
          label="司机"
          placeholder="请输入司机"
        />
        <van-field
          v-model="form.data.phone"
          name="phone"
          label="手机号码"
          placeholder="请输入手机号码"
        />
        <van-field
          v-model="form.data.weight"
          type="number"
          name="weight"
          label="重量（吨）"
          placeholder="请输入重量"
          required
          :rules="[{ required: true, message: '重量不能为空' }]"
        />
        <van-field
          name="startTime"
          label="开始时间"
          placeholder="请选择开始时间"
          :value="formatDate(form.data.startTime)"
          readonly
          clickable
          required
          :rules="[{ required: true, message: '请选择开始时间' }]"
          @click="form.datePicker.showStartPicker = true"
        />
        <van-popup
          v-model="form.datePicker.showStartPicker"
          position="bottom"
        >
          <van-datetime-picker
            v-model="form.datePicker.currentStart"
            type="datetime"
            title="选择开始时间"
            :min-date="form.datePicker.minDate"
            :max-date="form.datePicker.maxDate"
            @confirm="handleStartTimeConfirm"
          />
        </van-popup>
        <van-field
          name="endTime"
          label="结束时间"
          placeholder="请选择结束时间"
          :value="formatDate(form.data.endTime)"
          readonly
          clickable
          required
          :rules="[{ required: true, message: '请选择结束时间' }]"
          @click="form.datePicker.showEndPicker = true"
        />
        <van-popup
          v-model="form.datePicker.showEndPicker"
          position="bottom"
        >
          <van-datetime-picker
            v-model="form.datePicker.currentEnd"
            type="datetime"
            title="选择开始时间"
            :min-date="form.datePicker.minDate"
            :max-date="form.datePicker.maxDate"
            @confirm="handleEndTimeConfirm"
          />
        </van-popup>

        <div
          v-if="checkPermission([492])"
          style="margin: 0.6rem 1rem"
        >
          <van-button
            round
            block
            type="info"
            native-type="submit"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>
<script>
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import { Dialog } from "vant";

import { add as updateOne } from "@/api/unloading.js";
import { getConfigList, update } from "@/api/port.js";
import { getList } from "@/api/material";

import { pick } from "lodash";
import dayjs from "dayjs";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      query: {},
      portList: [],
      showPortPicker: false,
      materialList: [],
      showMaterialPicker: false,
      form: {
        data: {
          port: "",
          material: "",
          supplier: "",
          plateNumber: "",
          driver: "",
          phone: "",
          weight: 0,
          saveType: 1, // 1 为人工新增，0 为系统增加
          startTime: +new Date(),
          endTime: +new Date(),
        },
        datePicker: {
          showStartPicker: false,
          showEndPicker: false,
          minDate: new Date(2020, 1, 1),
          maxDate: new Date(2099, 1, 1),
          currentStart: new Date(),
          currentEnd: new Date(),
        },
      },
    };
  },
  computed: {
    pickerMaterialList() {
      return this.materialList.map((item) => item.name);
    },
    pickerPortList() {
      return this.portList.map((item) => ({
        text: item.portName,
        id: item.id,
      }));
    },
    selectPort() {
      return this.portList.find((port) => port.id === this.form.data.port)
        ?.portName;
    },
    startTime() {
      const { startTime } = this.form.data;
      return dayjs(startTime).format("YYYY-MM-DD HH:mm");
    },
    endTime() {
      const { endTime } = this.form.data;
      return dayjs(endTime).format("YYYY-MM-DD HH:mm");
    },
  },
  created() {
    const row = this.$route.query;
    this.query = row;
    if (Object.keys(row).length > 0) {
      this.form.data = {
        ...this.form.data,
        ...row,
        port: +row.port,
      };
    }

    this.getMaterialList();
    this.getPortList();
  },
  methods: {
    checkPermission,
    formatDate(val) {
      if (!val) return val;
      return dayjs(val).format("YYYY-MM-DD HH:mm");
    },
    handleStartTimeConfirm(value) {
      this.form.data.startTime = value;
      this.form.datePicker.showStartPicker = false;
    },
    handleEndTimeConfirm(value) {
      this.form.data.endTime = value;
      this.form.datePicker.showEndPicker = false;
    },
    handleConfirmPortPicker(value) {
      this.form.data.port = value.id;
      this.showPortPicker = false;
    },
    getMaterialList() {
      getList({ page: 1, limit: 1000 }).then(({ data: { data } }) => {
        const { items = [] } = data;
        this.materialList = items;
      });
    },
    getPortList() {
      getConfigList({ page: 1, limit: 1000 }).then(({ data: { data } }) => {
        this.portList = data;
      });
    },
    handleClickLeft() {
      this.$router.go(-1);
    },
    async handleConfirmMaterialType(value) {
      this.form.data.materialType = value;
      this.form.showMaterialTypePicker = false;
    },
    handleConfirmJarType(value) {
      this.form.data.jarType = value;
      this.form.showJarTypePicker = false;
    },
    async submit() {
      const payload = {
        id: this.query.id,
        ...pick(this.form.data, [
          "port",
          "material",
          "supplier",
          "plateNumber",
          "driver",
          "phone",
          "weight",
          "saveType",
          "startTime",
          "endTime",
        ]),
      };

      this.loading = true;

      await Dialog.confirm({
        title: "编辑新增原料入库记录？",
        message: "车牌号：" + payload.plateNumber,
        theme: "round-button",
      }).catch(() => {
        showPhoneAlarm(
          true,
          "toast",
          "success",
          2000,
          200,
          "编辑原料入库记录取消",
          "取消"
        );
        throw "编辑原料入库记录取消";
      });

      const { data } = await update(payload).finally(() => {
        this.loading = false;
      });

      if (
        showPhoneAlarm(
          true,
          "toast",
          null,
          2000,
          data.code,
          "新增原料入库",
          data.message ?? data.msg
        )
      ) {
        this.$router.push({
          path: "/service/history/port",
          query: {},
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding-bottom: 80px;
}
.supplier-edit-wrap {
  position: relative;

  .supplier-autocomplete {
    position: absolute;
    background-color: #fff;
    max-height: 230px;
    overflow-y: auto;
    left: 0;
    right: 0;
    z-index: 100;
    box-shadow: 0 12px 24px 0 rgba(0, 0, 0, 0.06);

    ::v-deep .van-cell {
      font-size: 14px;
      padding: 12px 18px;
    }
  }
}
</style>
